import { filter, take, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { PaymentBankAccountService } from '../provider/payment-bank-account.service';
import { ProfileType } from '../../../modules/profile/store/profile.entity';
import {
    PROFILE_DATA_OF_CURRENT_RECEIVED_SUCCESSFUL,
    ProfileDataReceivedSuccessfulAction
} from '../../../modules/profile/store/profile.action';
import { Observable } from 'rxjs';

@Injectable()
export class PaymentBankAccountEffects {
    constructor(private actions$: Actions,
                private paymentBankAccountService: PaymentBankAccountService) {
    }

     requestBankAccountData$: Observable<Action[] | Action> = createEffect(() => this.actions$.pipe(
        ofType(PROFILE_DATA_OF_CURRENT_RECEIVED_SUCCESSFUL),
        filter((action: ProfileDataReceivedSuccessfulAction) => action.payload.type === ProfileType.DOCTOR),
        tap(() => this.paymentBankAccountService.readPaymentBankAccount().pipe(take(1)).subscribe())
    ), {dispatch: false});
}
